<template>
  <div class="formUserInfo">
    <div class="wxchatBorderLeft">
      <div class="flex title">
        <h3>会话列表</h3>
        <i class="el-icon-circle-plus" @click="openCreateGroupChat(1)"></i>
      </div>
      <el-input v-model="chatNameSearch" suffix-icon="el-icon-search" class="contactName" placeholder="搜索联系人员"
                @change="getSearchKey"></el-input>
      <div class="conversationList">
        <div v-infinite-scroll="getChatList"
             infinite-scroll-disabled="loading" infinite-scroll-distance="10">
          <div class="conversation flex" @click="changeChatUser(item)" v-for="(item,index) in  chatList"
               :key="index"
               :class="[activeChat.id==item.id?'activeChat':'',item.isTop==1?'isTopClass':'']"
          >
            <div class="flex">
              <el-avatar :size="40" v-if="item.chatType==1" :src="item.chatAvatarPath"></el-avatar>
              <el-avatar :size="40" v-if="item.chatType==2" src="/static/imgs/chat_group.png"></el-avatar>
            </div>
            <div class="rightText flex">
              <span class="chatName" v-if="item.chatType==1">{{ item.chatName }}</span>
              <span class="chatName"
                    v-if="item.chatType==2">{{ item.chatName ? item.chatName : (item.masterName + '创建的群聊') }}</span>

              <img src="/static/default_imgs/disturb.png" v-if="item.isMute==1" alt="" width="25">
              <el-badge class="flex" :value="item.unreadNum" :max="99" v-show="item.unreadNum>0&&item.isMute==0"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rightChat">
      <div class="wxchatBorderRightTop flex">
            <span class="chatNameActive">
              <template v-if="activeChat.chatType==1">{{ activeChat.chatName }}</template>
              <template v-if="activeChat.chatType==2"> {{
                  activeChat.chatName ? activeChat.chatName : (activeChat.masterName + '创建的群聊')
                }}</template>
            </span>
        <span v-if="activeChat.chatType==2">
              ({{ activeChat.memberNum }})
            </span>
        <span class="checkInfo" @click="innerDrawer = !innerDrawer">
              <img src="../../assets/img/checkInfo.png" alt="" width="24">
            </span>
      </div>
      <div class="chatContent" @click="innerDrawer=false">
        <div class="wxchatBorderRightMid" id="chatRecord">
          <p class="seeMore clickable" align="center" v-if="activeChatHistory.maxPage>activeChatHistory.current"
             @click="showMsgHistory">---- 查看更多消息 ----</p>
          <p class="seeMore" align="center" v-else>---- 没有更多消息 ----</p>
          <el-row v-for="msg in activeChatHistory.list" :key="msg.id">
            <template v-if="msg.memberId == curUser.id">
              <div align="right" class="time" style="margin-right: 7%">
                {{ new Date(msg.msgTimestamp).Format('yyyy-MM-dd HH:mm:ss') }}
              </div>
              <el-col :span="23">
                <div class="chatPop2 chatPop">
                  <div v-if="msg.msgType === 1" @contextmenu.prevent="copyText($event)">
                    <a v-if="isUrl(msg.msgContent)" target="_blank"
                       :href="msg.msgContent">{{ msg.msgContent }}</a>
                    <div v-else>{{ msg.msgContent }}</div>
                  </div>
                  <div v-else-if="msg.msgType === 2">
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="msg.msgContent"
                        :preview-src-list="[msg.msgContent]"
                        fit="contain"></el-image>
                  </div>
                </div>
              </el-col>
              <el-col :span="1">
                <el-avatar :src="memberAvatarMap.get(msg.memberId)" :size="40"></el-avatar>
              </el-col>
            </template>
            <template v-else>
              <div align="left" class="time" style="margin-left: 7%">
                {{ new Date(msg.msgTimestamp).Format('yyyy-MM-dd HH:mm:ss') }}
              </div>
              <el-col :span="1">
                <el-avatar :src="memberAvatarMap.get(msg.memberId)" :size="40"></el-avatar>
              </el-col>
              <el-col :span="23">
                <div class="chatPop1 chatPop" style="margin-left: 20px;">
                  <div v-if="msg.msgType === 1" @contextmenu.prevent="copyText($event)">
                    <a v-if="isUrl(msg.msgContent)" target="_blank"
                       :href="msg.msgContent">{{ msg.msgContent }}</a>
                    <div v-else>{{ msg.msgContent }}</div>
                  </div>
                  <div v-else-if="msg.msgType === 2">
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="msg.msgContent"
                        :preview-src-list="[msg.msgContent]"
                        fit="contain"></el-image>
                  </div>
                </div>
              </el-col>
            </template>
          </el-row>
        </div>
        <div class="wxchatBorderRightBottom">
          <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="msgContent" resize="none" autofocus
                    maxlength="500">
          </el-input>
          <div class="sendButton">
            <el-button size="mini" class="custom" @click="clickImgBtn()">上传图片</el-button>
            <el-button size="mini" @click="sendTextMessage(1)">发送</el-button>
          </div>
          <div style="clear: both"></div>
        </div>
      </div>
      <transition name="el-fade-in-linear">
        <div v-show="innerDrawer" class="transition-box ">
          <template v-if="activeChat.chatType==2">
            <div class="flex searchGroup">
              <el-input v-model="groupMemSearch" suffix-icon="el-icon-search" class="contactName"
                        placeholder="搜索群成员" @change="getSearchMember"></el-input>
              <span class="iconPlus" v-if="activeChat.chatType==2 && curUser.id==activeChat.masterId"
                    @click="getSelectUser(2)"><i class="el-icon-plus"></i></span>
            </div>
            <div class="memberGroupList">
              <div class="conversation flex" v-for="(item,index) in  selectMemberDialog.selectChat"
                   :key="item.id + '_' + index" v-show="isOpen || index < max">
                <el-avatar :size="36" fit="cover" :src="item.memberHeadImg"></el-avatar>
                <div class="rightText flex ">
                        <span class="chatName">
                          {{ item.nickname }}
                        </span>
                  <span class="manager" v-if="item.memberId ==  activeChat.masterId">@群主</span>
                </div>
                <i class="el-icon-circle-close close" @click="delUser(item)"
                   v-if="item.memberId !==  activeChat.masterId"></i>
              </div>
            </div>
            <p class="moreCheck" v-show="!isOpen && selectMemberDialog.selectChat.length > max"
               @click="isOpen = !isOpen">查看更多群成员
              <i class="el-icon-arrow-down"></i></p>
            <p class="moreCheck" v-show="isOpen && selectMemberDialog.selectChat.length > max"
               @click="isOpen = !isOpen">收起 <i
                class="el-icon-arrow-up"></i></p>
          </template>
          <div class="activeChatUser flex" v-else>
            <el-avatar :size="36" fit="cover" :src="activeChat.chatAvatarPath"></el-avatar>
            <span class="chatName"> {{ activeChat.chatName }}</span>
          </div>
          <div class="operation" style="padding-bottom: 0" v-if="activeChat.chatType==2 ">
            <span>群名称</span>
            <el-input class="masterName" suffix-icon="el-icon-edit"
                      :disabled="curUser.id==activeChat.masterId?false:true"
                      v-model="updateChat" placeholder="请输入群昵称"
                      @change="submitChatName"></el-input>
          </div>
          <div class="flex operation">
            <span>消息免打扰</span>
            <el-switch
                @change="disturbClick"
                v-model="activeChat.isMute"
                :active-value="1"
                :inactive-value="0"
                active-color="#567BFF"
                inactive-color="#C5CBDF">
            </el-switch>
          </div>
          <div class="flex operation">
            <span>置顶聊天</span>
            <el-switch
                @change="topClick"
                v-model="activeChat.isTop"
                :active-value="1"
                :inactive-value="0"
                active-color="#567BFF"
                inactive-color="#C5CBDF">
            </el-switch>
          </div>
          <span class="operation dismiss" v-if="activeChat.chatType==2 && curUser.id==activeChat.masterId"
                @click="dismiss">解散群聊</span>
        </div>
      </transition>
    </div>
    <input id="el_copy_input" style="display: none;border: none;color: transparent;" type="text" v-model="copy_input"/>
    <input id="img_file_input" type="file" ref="uploadImageInput" accept="image/png,image/jpeg,image/gif,image/jpg"
           style="display: none;" @change="sendImageMessage()"/>

    <!--    创建群聊: 选择人员   -->
    <el-dialog
        class="groupChat"
        top="0" :close-on-click-modal="false" @close="close"
        :visible.sync="selectMemberDialog.show" :close-on-press-escape="false"
        width="600px">
      <span slot="title"></span>
      <div class="left">
        <el-tabs value="医生" class="tabUser" v-model="selectMemberDialog.activeTab" @tab-click="change">
          <el-tab-pane :name="item.name" :label="item.label" v-for="(item,ind) in group" :key="ind">
            <el-input v-model="selectMemberDialog.page.name" suffix-icon="el-icon-search" class="userSearch"
                      placeholder="请输入搜索姓名" @change="search"></el-input>
            <div v-if="selectMemberDialog.page.rows.length==0"
                 style="text-align: center;color: #DFE0E7;width: 100%">
              <img src="../../assets/img/empty_tips.png" alt="" width="100%">
              <div>暂无数据</div>
            </div>
            <el-checkbox-group v-model="selectMemberDialog.selectedUser" :max="10" class="checkList"
                               style="overflow-y: auto" v-infinite-scroll="loadInfo">
              <el-checkbox :label="item.id" @change="handleCheckChange($event,item)"
                           :disabled="item.id ==  activeChat.masterId?true:false"
                           v-for="(item,index) in selectMemberDialog.page.rows" :key="index">
                <el-avatar :size="40" :src="item.headImgPath" fit="cover"></el-avatar>
                <span class="name">{{ item.fullName }} {{ item.enName }}</span>
              </el-checkbox>
            </el-checkbox-group>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="rightDialog">
        <p class="title">
          <template v-if="selectMemberDialog.allCheckedMember.length===0">请勾选需要添加的联系人</template>
          <template v-else>已勾选联系人</template>
        </p>
        <div class="checkedList">
          <div v-for="(item,index) in selectMemberDialog.allCheckedMember" :key="index" class="flex">
            <el-avatar :size="34" :src="item.headImgPath"></el-avatar>
            <span class="name">{{ item.fullName }} {{ item.enName }}</span>
            <i class="el-icon-circle-close" v-if="item.memberId !==  activeChat.masterId"
               @click="delUser1(item,index)"></i>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" size="mini" :loading="selectMemberDialog.btnLoad" @click="doCreateGroupChat">确定
          </el-button>
          <el-button size="mini"
                     @click="close">取消
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import base from '@/api/common'
import qs from 'qs'

export default {
  name: "sessionList",
  props: ['chatGroup', 'type'],
  data() {
    return {
      curUser: {
        id: localStorage.curUid,
      },
      redirectId: this.$route.params.id,
      chatList: [],
      chatNameSearch: '',
      chatSearch: '',
      // 搜索会话关键字
      chat: {
        current: 1,
        size: 10
      },
      loading: false,
      activeChat: {
        id: '',
      },
      activeChatHistory: {
        chatId: '',
        list: [],
        current: 1,
        size: 10,
        total: 0,
        maxPage: 1,
      },
      msgContent: '', // 文本域聊天内容,
      memberAvatarMap: new Map(),
      chatListIndexMap: new Map(),
      msgTimer: 0,
      copy_input: '',
      imgUploadUrl: base.uploadUrl + 'communicate',

      group: [{label: "医生", name: 'doctor'}, {label: "用户", name: 'user'}],
      selectMemberDialog: { // 选择人员弹窗内容
        show: false,
        type: 1,
        activeTab: 'doctor',
        btnLoad: false,
        allCheckedMember: [], // 所有选中成员(包含医生,用户)
        selectedUser: [],
        page: {
          name: '',
          current: 1,
          size: 10,
          total: 8,
          rows: [],
          finish: false // 是否最后一页
        },
        selectChat: []
      },
      // 修改名称
      updateChat: '',
      // 列表窗口
      innerDrawer: false,
      groupMemSearch: '',
      isOpen: false,
      max: 4,
    }
  },
  inject: ['reload'],
  mounted() {
    // 1. 加载聊天列表
    let that = this;
    // that.getChatList();

    // 获取新消息
    if (that.msgTimer) {
      return;
    }
    let chat_failCount = 0;
    that.msgTimer = setInterval(() => {
      if (chat_failCount >= 10) {
        clearInterval(that.msgTimer);
        return;
      }
      that.$ajax.post(base.api.communication.chat.unreadList).then(res => {
        if (res.data.status === 'success') {
          res.data.list.forEach(item => {
            let index = that.chatListIndexMap.get(item.chatId);
            if (index || index == 0) {
              that.chatList[index].unreadNum = item.unreadNum;
            }
            // 获取新消息
            if (that.activeChat.id == item.chatId) {
              that.getChatHistory(item.chatId, true);
              // 此时清空未读
              that.clearUnreadChar(item.chatId);
            }
          })
        }
      }).catch(err => {
        chat_failCount++;
        console.error(err);
      });
    }, 2000);

  },
  destroyed() {
    clearInterval(this.msgTimer);
  },
  methods: {
    // 复制文本
    copyText(e) {
      this.copy_input = $(e.target).text();
      document.getElementById('el_copy_input').style.display = 'block';
      this.$nextTick(() => {
        document.getElementById('el_copy_input').select();
        document.execCommand("copy");
        document.getElementById('el_copy_input').style.display = 'none';
      });
      this.$message.success('内容复制成功');
    },

    // 切换人员
    async changeChatUser(item) {
      this.innerDrawer = false
      if (item && item.id) {
        if (this.activeChat.id == item.id) {
          return;
        }
        this.activeChatHistory.list.length = 0;
        this.activeChat = item;
        this.updateChat = this.activeChat.chatName ? this.activeChat.chatName : (this.activeChat.masterName + '创建的群聊')

        await this.getMemberList(item.id);
        this.getChatHistory(item.id);
        this.clearUnreadChar(item.id);
      }
    },

    // 获取会话列表
    getChatList() {
      let that = this;
      that.loading = true
      that.$ajax.get(base.api.communication.chat.list_me.replace('{pg}', that.chat.current).replace('{ps}', that.chat.size) + '?name=' + that.chatSearch)
          .then(async res => {
            if (res.data.status === 'success') {
              let list = []
              list.push(...res.data.rows);
              // 先清空会话
              // that.chatList.length = 0;
              let createActive = false;
              // 从群聊列表进来
              if (that.chatGroup) {
                if (that.type == 2) {
                  this.activeChat = that.chatGroup
                  that.selectTop();
                  that.getChatHistory(that.chatGroup.id, true);
                } else {
                  that.redirectId = that.chatGroup
                }
              }

              list.forEach((item, index) => {
                that.chatListIndexMap.set(item.id, index);
                // 显示处理
                if (item.chatType == 1) { //私聊
                  if (that.curUser.id == item.masterId) {
                    item.chatName = item.inviteeName;
                    item.chatAvatarPath = item.inviteeAvatar;
                  } else {
                    item.chatName = item.masterName;
                    item.chatAvatarPath = item.masterAvatar;
                  }
                }
                if (that.redirectId && item.id == that.redirectId) {
                  // 新回话置顶处理
                  if (that.chat.current == 1) {
                    createActive = true;
                    that.chatList.unshift(item);
                  } else {
                    list.splice(index, 1);
                    that.chatList.unshift(item);
                  }
                } else {
                  that.chatList.push(item);
                }
              });

              if (that.redirectId && !createActive) { // 从私信==>未激活聊天
                // 单独添加
                await that.$ajax.get(base.api.communication.chat.one.replace('{id}', that.redirectId)).then(res => {
                  if (res.data.status === 'success') {
                    let topChat = res.data.data;
                    if (topChat.chatType == 1) { //私聊
                      if (that.curUser.id == topChat.masterId) {
                        topChat.chatName = topChat.inviteeName;
                        topChat.chatAvatarPath = topChat.inviteeAvatar;
                      } else {
                        topChat.chatName = topChat.masterName;
                        topChat.chatAvatarPath = topChat.masterAvatar;
                      }
                    }
                    if (that.chat.current == 1) {
                      that.chatList.unshift(topChat);
                    }

                    // 选中首个
                    that.selectTop();
                  }
                })
              }

              this.chat.current = res.data.current
              this.chat.size = res.data.size
              let totalLength = res.data.current * res.data.size;
              if (totalLength >= res.data.total || res.data.total <= res.data.size) {
                this.loading = true;
              } else {
                this.loading = false;
                this.chat.current++;
              }
              // 选中首个
              that.selectTop();

            } else {
              that.$message.error('信息加载失败');
            }
          }).catch(err => {
        console.error(err);
        that.$message.error('信息加载失败');
      });
    },

    // 会话列表--搜索
    getSearchKey() {
      this.chatSearch = this.chatNameSearch
      this.chatList = [];
      this.chat.current = 1;
      this.loading = false
      this.getChatList()
    },

    // 选择第一个
    selectTop() {
      // 2. 选中首个
      let that = this;
      if (that.activeChat && that.activeChat.id) {
        return;
      }
      that.$nextTick(async () => {
        if (that.chatList.length > 0) {
          that.activeChat = that.chatList[0];
          this.updateChat = this.activeChat.chatName ? this.activeChat.chatName : (this.activeChat.masterName + '创建的群聊')
          // 获取成员信息
          await that.getMemberList(that.chatList[0].id);
          // 获取聊天记录
          that.getChatHistory(that.chatList[0].id, true);
        }
      });
    },

    // 历史记录
    showMsgHistory() {
      let that = this;
      that.activeChatHistory.current++;
      that.getChatHistory(that.activeChat.id);
    },
    getChatHistory(id, isSend) {
      let that = this;
      that.activeChatHistory.chatId = id;
      that.$ajax.get(base.api.communication.chat.message.replace('{id}', id) + '?page=' + that.activeChatHistory.current).then(res => {
        if (res.data.status === 'success') {
          if (that.activeChatHistory.current == 1) {
            that.activeChatHistory.list.length = 0;
          }
          that.activeChatHistory.list = [...res.data.rows.reverse(), ...that.activeChatHistory.list];
          that.activeChatHistory.current = res.data.current;
          that.activeChatHistory.size = res.data.size;
          that.activeChatHistory.total = res.data.total;
          that.activeChatHistory.maxPage = Math.ceil(res.data.total / res.data.size);
        }
      }).catch(err => {
        console.error(err);
        that.$message.error('聊天信息加载失败');
      });
    },

    // 获取成员信息
    async getMemberList(id) {
      let that = this, url;
      if (!this.groupMemSearch) {
        url = base.api.communication.chat.member.list.replace('{id}', id)
      } else {
        url = base.api.communication.chat.member.name.replace('{id}', id) + '?name=' + this.groupMemSearch
      }
      await that.$ajax.get(url).then(async res => {
        if (res.data.status === 'success') {
          this.selectMemberDialog.selectChat = res.data.list
          res.data.list.forEach((item, index) => {
            that.memberAvatarMap.set(item.memberId, item.memberHeadImg);
            if (item.memberId == this.activeChat.masterId) {
              that.selectMemberDialog.selectChat.splice(index, 1)
              that.selectMemberDialog.selectChat.unshift(item);
            }
          })
        }
      }).catch(err => {
        console.error(err);
        that.$message.error('成员信息加载失败');
      })
    },
    // 清除未读
    clearUnreadChar(chatId) {
      this.$ajax.post(base.api.communication.chat.cleanChatUnread.replace('{id}', chatId));
    },
    // 发送消息
    sendTextMessage(msgType) {
      let that = this;
      if (!that.activeChat.id) {
        that.$message.info('发送对象不能为空');
        return;
      }
      let msgContent = that.msgContent;
      if ($.trim(msgContent).length === 0) {
        that.$message.info('内容不能为空');
        return;
      }
      that.$ajax.post(base.api.communication.chat.sendText.replace('{id}', that.activeChat.id), {
        msgContent, msgType
      }).then(res => {
        if (res.data.status === 'success') {
          that.activeChatHistory.list.length = 0;
          that.activeChatHistory.current = 1;
          that.getChatHistory(that.activeChat.id, true); //刷新聊天数据
          that.msgContent = '';
        } else {
          that.$message.error('发送失败');
        }
      }).catch(err => {
        that.$message.error('发送失败');
      });
    },
    clickImgBtn() {
      $('#img_file_input').click();
    },
    // 发送图片
    sendImageMessage() {
      let inputEle = this.$refs.uploadImageInput;
      let files = inputEle.files;
      if (files.length == 0) {
        return;
      }
      let that = this;

      let formData = new FormData();
      formData.append('uploadFile', files[0]);

      this.$ajax.post(base.api.communication.chat.sendImg.replace('{id}', that.activeChat.id), formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
        if (res.data.status === 'success') {
          that.activeChatHistory.list.length = 0;
          that.activeChatHistory.current = 1;
          that.getChatHistory(that.activeChat.id, true); //刷新聊天数据
          that.msgContent = '';
        } else {
          that.$message.error('发送失败');
        }
      }).catch(err => {
        console.error(err);
        that.$message.error('发送失败');
      });
    },
    //是否是链接
    isUrl(strUrl) {
      let strRegex = '^((https|http|ftp)://)?'//(https或http或ftp):// 可有可无
          + '(([\\w_!~*\'()\\.&=+$%-]+: )?[\\w_!~*\'()\\.&=+$%-]+@)?' //ftp的user@  可有可无
          + '(([0-9]{1,3}\\.){3}[0-9]{1,3}' // IP形式的URL- 3位数字.3位数字.3位数字.3位数字
          + '|' // 允许IP和DOMAIN（域名）
          + '(localhost)|'	//匹配localhost
          + '([\\w_!~*\'()-]+\\.)*' // 域名- 至少一个[英文或数字_!~*\'()-]加上.
          + '\\w+\\.' // 一级域名 -英文或数字  加上.
          + '[a-zA-Z]{1,6})' // 顶级域名- 1-6位英文
          + '(:[0-9]{1,5})?' // 端口- :80 ,1-5位数字
          + '((/?)|' // url无参数结尾 - 斜杆或这没有
          + '(/[\\w_!~*\'()\\.;?:@&=+$,%#-]+)+/?)$';//请求参数结尾- 英文或数字和[]内的各种字符
      let re = new RegExp(strRegex, 'i');//i不区分大小写
      if (re.test(encodeURI(strUrl))) {
        return true;
      } else {
        return false;
      }
    },
    /* removeUrlParams(url) {
       if (!url) {
         return ''
       }
       return url.split('/')[2];
     },*/
    // 打开选择、添加群聊成员
    openCreateGroupChat(val) {
      this.selectMemberDialog.type = val
      // 3. 恢复默认信息
      this.selectMemberDialog.show = true;
      this.loadInfo();
    },
    close() {
      this.selectMemberDialog.page.current = 1
      this.selectMemberDialog.page.rows.length = 0;
      this.selectMemberDialog.page.name = '';
      this.selectMemberDialog.selectedUser.length = 0;
      this.selectMemberDialog.allCheckedMember.length = 0;
      this.selectMemberDialog.btnLoad = false;
      this.selectMemberDialog.show = false
      this.getMemberList(this.activeChat.id)
    },
    // 回显
    getSelectUser(val) {
      this.selectMemberDialog.type = val
      this.selectMemberDialog.show = true;
      this.selectMemberDialog.page.rows.length = 0;
      this.selectMemberDialog.page.finish = false;
      this.loadInfo();
      this.selectMemberDialog.selectChat.forEach((item) => {
        item.isCheck = true
        item.headImgPath = item.memberHeadImg
        item.id = item.memberId
        item.fullName = item.nickname
        this.selectMemberDialog.allCheckedMember.push(item)
      })
    },

    // 切换
    change() {
      this.selectMemberDialog.page.current = 1;
      this.selectMemberDialog.page.rows.length = 0;
      this.selectMemberDialog.page.finish = false;
      // this.loadInfo();
    },
    // 搜索
    search() {
      this.selectMemberDialog.page.current = 1;
      this.selectMemberDialog.page.rows.length = 0;
      this.selectMemberDialog.page.finish = false;
      this.loadInfo();
    },
    loadInfo() {
      let that = this, url, params;
      params = {
        page: that.selectMemberDialog.page.current,
        size: 10,
      }
      if (this.selectMemberDialog.activeTab == 'doctor') {
        url = 'communication/comm-contacts/authorize/page/contacts'
        params['keyword'] = that.selectMemberDialog.page.name;
      } else {
        url = 'auth/doctor-patients/authorize/page/user/base-info'
        params['name'] = that.selectMemberDialog.page.name;
        params = qs.stringify(params)
      }
      if (that.selectMemberDialog.page.finish) {
        return;
      }
      this.$ajax.post(base.basePath + url, params).then(res => {
        if (res.data.status === 'success') {
          if (that.selectMemberDialog.page.rows.length > 0 && res.data.current === 1) {
            return;
          }
          res.data.rows.forEach((item, index) => {
            item.memberType = this.selectMemberDialog.activeTab == 'doctor' ? 2 : 1;
            if (item.memberType == 2) {
              item.fullName = item.contactAlias
              item.headImgPath = item.avatar
              item.id = item.contactId
            }
            this.selectMemberDialog.allCheckedMember.forEach((obj) => {
              if (obj.id == item.id) {
                this.selectMemberDialog.selectedUser.push(obj.memberId)
              }
            })
          })
          let totalPage = Math.ceil(res.data.total / res.data.size);
          if (res.data.current >= totalPage) {
            that.selectMemberDialog.page.finish = true;
          } else {
            that.selectMemberDialog.page.finish = false;
            that.selectMemberDialog.page.current++;
          }
          this.selectMemberDialog.page.rows.push(...res.data.rows);
        }
      })
    },
    getChatInfo(id) {
      let that = this;
      that.$ajax.get(base.api.communication.chat.one.replace('{id}', id)).then(res => {
        if (res.data.status === 'success') {
          this.activeChat.memberNum = res.data.data.memberNum
        }
      }).catch(err => {
        console.error(err);
        that.$message.error('获取数据失败');
      });
    },
    // 点击选中
    handleCheckChange(event, item) {
      if (event == true) {
        this.selectMemberDialog.allCheckedMember.push(item);
        // console.log(this.selectMemberDialog.allCheckedMember)
      } else { // 取消选中
        $(this.selectMemberDialog.allCheckedMember).each((index, dataA) => {
          if (dataA.id == item.id && dataA.isCheck == true) {
            dataA.chatId = this.activeChat.id
            dataA.memberId = dataA.id
            dataA.id = item.id
            this.delUser1(dataA, index)
          } else if (dataA.id == item.id) {
            this.selectMemberDialog.allCheckedMember.splice(index, 1);
            return false;
          }
        })
      }
    },
    // 删除
    delUser(item) {
      this.$confirm('确定删除群成员 ' + item.nickname + '?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (item.chatId) {
          let vm = this
          vm.$ajax.post(base.basePath + 'communication/comm-chat-member/authorize/remove/' + item.chatId + '?id=' + item.memberId).then(res => {
            if (res.data.status === 'success') {
              this.$message.success("删除成功");
              this.selectMemberDialog.page.rows.forEach((obj) => {
                if (obj.id == item.id) {
                  this.selectMemberDialog.selectedUser.splice(this.selectMemberDialog.selectedUser.indexOf(obj.id), 1)
                }
              })
              this.$nextTick(() => {
                this.getChatInfo(this.activeChat.id)
                this.getMemberList(this.activeChat.id)
              })
            } else {
              this.$message.error("删除失败");
            }
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    delUser1(item, index) {
      if (item.chatId) {
        let vm = this
        vm.$ajax.post(base.basePath + 'communication/comm-chat-member/authorize/remove/' + item.chatId + '?id=' + item.memberId).then(res => {
          if (res.data.status === 'success') {
            this.$message.success("删除成功");
          } else {
            this.$message.error("删除失败");
          }
        })
      }
      this.selectMemberDialog.allCheckedMember.splice(index, 1);
    },
    // 创群聊
    doCreateGroupChat() {
      let that = this, url;
      if (this.selectMemberDialog.type == 2) {
        // 添加群聊成员
        url = 'communication/comm-chat-member/authorize/add/' + that.activeChat.id;
      } else {
        // 创建群聊
        url = 'communication/comm-chat/authorize/create/group';
      }
      let members = that.selectMemberDialog.allCheckedMember.map((item) => {
        if (item.memberType == 1) {
          return {
            memberId: item.id,
            memberType: item.memberType
          };
        } else {
          return {
            memberId: item.contactId,
            memberType: item.memberType
          };
        }
      });
      if (members.length < 1) {
        that.$message.warning('请至少选择一个用户');
        return;
      }
      that.selectMemberDialog.btnLoad = true;
      that.$ajax.post(base.basePath + url, members).then(res => {
        if (res.data.status === 'success') {
          this.selectMemberDialog.btnLoad = false;
          this.selectMemberDialog.show = false
          if (this.selectMemberDialog.type == 2) {
            that.$message.success('添加成功');
            this.$nextTick(() => {
              this.getChatInfo(this.activeChat.id)
              this.getMemberList(this.activeChat.id)
            })
          } else {
            that.$message.success('创建成功');
            this.$nextTick(() => {
              this.chatList.length = 0
              this.getChatList()
            })
          }
          this.innerDrawer = false
        } else {
          that.$message.error(res.data.message);
          this.selectMemberDialog.btnLoad = false;
        }
      }).catch(err => {
        that.$message.error('创建失败');
        this.selectMemberDialog.btnLoad = false;
      })
    },
    // 群名称
    submitChatName() {
      let vm = this
      vm.$ajax.post(base.basePath + 'communication/comm-chat/authorize/rename/' + vm.activeChat.id + '?name=' + this.updateChat).then(res => {
        if (res.data.status === 'success') {
          vm.$message.success("修改成功");
          this.activeChat.chatName = this.updateChat
          this.innerDrawer = false
        } else {
          vm.$message.error("修改失败");
        }
      })
    },
    // 搜索成员列表
    getSearchMember(value) {
      this.groupMemSearch = value
      this.selectMemberDialog.selectChat.length = 0;
      this.getMemberList(this.activeChat.id)
    },
    // 免打扰
    disturbClick() {
      let that = this;
      that.$ajax.post(base.api.communication.chat.disturb.replace('{id}', that.activeChat.id).replace('{status}', that.activeChat.isMute))
          .then((res) => {
            if (res.data.status == 'success') {
              // that.getChatList()
              this.innerDrawer = false
            }
          });
    },
    // 置顶
    topClick() {
      let that = this;
      that.$ajax.post(base.api.communication.chat.setTop.replace('{id}', that.activeChat.id).replace('{status}', that.activeChat.isTop))
          .then((res) => {
            if (res.data.status == 'success') {
              that.chatList.forEach((item, index) => {
                if (item.isTop == 1) {
                  that.chatList.splice(index, 1)
                  that.chatList.unshift(item);
                }
              })
              this.innerDrawer = false
            }
          });
    },
    // 解散群聊
    dismiss() {
      let that = this;
      this.$confirm('确定删除并解散群聊?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.$ajax.post(base.api.communication.chat.dismiss.replace('{id}', that.activeChat.id))
            .then((res) => {
              if (res.data.status == 'success') {
                that.$message.success("解散群聊成功");
                this.$nextTick(() => {
                  this.chatList.length = 0
                  this.getChatList()
                })
                this.innerDrawer = false
              }
            });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  },
  watch: {
    activeList(val, oldVal) {
      if (oldVal.length === 0) {
        this.$nextTick(() => {
          document.querySelector("#chatRecord").scrollTop = document.querySelector("#chatRecord").scrollHeight;
        })
      }
    }
  },
  computed: {
    activeList() {
      return this.activeChatHistory.list;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/communicate.scss";
</style>
